import React from 'react';
import styled from 'styled-components';

const StyledBreakContainer = styled.div`
  width: 100%;
`;
const StyledBreak = styled.div`
  height: 1px;
  width: 100%;
  opacity: 0.1;
  background-color: #061e37;
  margin: ${({ margin }) => margin || '0'};
`;

const Break = ({ children, ...props }) => {
  return (
    <StyledBreakContainer>
      <StyledBreak {...props}>{children}</StyledBreak>
    </StyledBreakContainer>
  );
};

export default Break;
